export const SUPERLOGICA = { label: 'Superlógica', value: 'SUPERLOGICA' };

export const TIPO_INTEGRACAO_ENUM_VALUES = [SUPERLOGICA];
